import React from "react";

export const BlogCard = ({ item }) => {
    return (
        <div className="w-full bg-white rounded-lg  ">
            {/* Ảnh */}
            <div className="rounded-lg w-full h-60 overflow-hidden">
                <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover hover:scale-[1.1] transition-all duration-300 "
                />
            </div>
            {/* Nội dung */}
            <div className="p-3 flex flex-col gap-2 w-full">

                <div className="text-xs text-gray-500 flex items-center gap-2">
                    <span>{item.date}</span>
                    <span>•</span>
                    <span>{item.author}</span>
                </div>


                <h3 className="text-sm font-semibold leading-5 hover:text-[--color-button-3] cursor-pointer">
                    {item.title}
                </h3>


                <a
                    href={item.link}
                    className="text-xs font-medium text-gray-500 hover:underline mt-1"
                >
                    Read More
                </a>
            </div>
        </div>
    );
};
